import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CandleStickChart from '../stock/CandlestickChart';
import AlgoDrawer from '../algos/AlgoDrawer'
import StockQuickLookDrawer from '../stock/StockQuickLookDrawer.js'
import JSONViewer from "../components/JSONViewer";
import IndicatorSelector from '../stock/IndicatorSelector';
import ActionResult from "../components/ActionResult.js";

function TradeDetails(props) {

    let { planTradeId } = useParams();

    const [tradeDetails, setTradeDetails] = useState(null);
    const [tradeId] = useState(planTradeId ? planTradeId : props.planTradeId)
    const [note, setNote] = useState("");
    const [result, setResult] = useState(null);
    const [indicatorOptions, setIndicatorOptions] = useState([]);
    const [patterns, setPatterns] = useState([]);
    const [selectedIndicators, setSelectedIndicators] = useState(() => {
        const saved = localStorage.getItem('tradeReviewIndicators');
        if (saved) {
            try {
                return JSON.parse(saved);
            } catch (e) {
                return [];
            }
        }
        return [];
    });

    useEffect(() => {
        localStorage.setItem('tradeReviewIndicators', JSON.stringify(selectedIndicators));
    }, [selectedIndicators]);

    useEffect(() => {
        (async function () {
            try {
                const options = await (await fetch(`/api/indicators`)).json();
                setIndicatorOptions(options.indicators || []);
                setPatterns(options.patterns || []);
            } catch (e) {
                console.error("Failed to fetch indicators", e);
            }
        })();
    }, []);

    useEffect(() => {
        (async function () {

            const url = `/api/tradeDetails?planTradeId=` + tradeId + "&userId=" + props.userId;
            const text = await (await fetch(url)).json();
            console.log("Trade Details: ", text);
            if (text.err) {
            } else {
                setTradeDetails(text.trade);
                setNote(text.trade.note);
            }
        })();
    }, [tradeId, props.userId]);

    let trades = [];
    if (tradeDetails) {
        trades.push({
            purchase_date: tradeDetails.purchase_date,
            sell_date: tradeDetails.sell_date,
            purchase_price: tradeDetails.purchase_price,
            sell_price: tradeDetails.sell_price,
            allocation: tradeDetails.allocation
        })
    }

    const saveNote = async () => {
        const url = `/api/tradeNote?planTradeId=${tradeId}&userId=${props.userId}&note=${note}`;
        const text = await (await fetch(url, { method: 'POST' })).json();
        console.log(text);
        if (text.error) {
            setResult(text);
        }
    }

    return (
        <>
            {tradeDetails ?
                <>
                    <div className='sameline'>Algo: <AlgoDrawer link={tradeDetails.display_name} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={tradeDetails.algoId} role={props.role} /></div>
                    <div className='sameline'>Symbol: <StockQuickLookDrawer symbol={tradeDetails.trade_symbol} planId={props.planId} mobileView={props.mobileView} userId={props.userId} accountId={props.accountId} /></div>
                    <br></br>
                    Entry: {new Date(tradeDetails.purchase_date).toLocaleDateString()} at {tradeDetails.purchase_price}
                    <br></br>
                    Exit: {tradeDetails.sell_date ? new Date(tradeDetails.sell_date).toLocaleDateString() + " at " + tradeDetails.sell_price : ""}
                    <br></br>
                    <br></br>
                    <IndicatorSelector indicators={indicatorOptions} selectedIndicators={selectedIndicators} setSelectedIndicators={setSelectedIndicators} patterns={patterns} />
                    <br></br>
                    <CandleStickChart showMovingAverage={false} showAveragePrice={true} symbol={tradeDetails.trade_symbol} trades={trades} indicators={selectedIndicators} width={400} height={300} />
                    <br></br>
                    <textarea rows={3} cols={70} placeholder="Notes" onChange={(e) => setNote(e.target.value)} value={note} />
                    <br></br>
                    <button onClick={saveNote}>Save Note</button>
                    <br></br>
                    Entry Data:
                    <JSONViewer data={tradeDetails.purchase_data} />
                    <br></br>
                    Exit Data: {tradeDetails.sell_reason}
                    <JSONViewer data={tradeDetails.sell_data} />
                    <ActionResult result={result} />
                </>
                : null}
        </>
    );
}

export default TradeDetails;